/**
 * Text used when displaying the portal brand name
 */
export enum brandPortalNames {
  heg = 'Highlights Portal',
  zb = 'My ZB Portal'
}
